import { render, staticRenderFns } from "./BusinessInformationComponent.vue?vue&type=template&id=b1ccefd8&"
import script from "./BusinessInformationComponent.vue?vue&type=script&lang=js&"
export * from "./BusinessInformationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports